var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-tile-title.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productLink"), env.opts.autoescape);
output += "\" class=\"c-product-tile__title-link js-product-tile-title-link\" data-product-slug=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")),"productSlug"), env.opts.autoescape);
output += "\" data-qa-product-tile-title-link>\n\n    <h3 class=\"c-product-tile__h3 c-product-tile__h3--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tileTemplate"), env.opts.autoescape);
output += "\" data-qa-prod-title>\n        <span>\n            ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productTileName"), env.opts.autoescape);
output += "\n        </span>\n    </h3>\n\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-tile-title.j2"] , dependencies)